import { TransparentButton } from '@libs/components';
import { DropdownIcon } from 'src/assets';
import styled from 'styled-components';

export const TextContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 1.2rem 0 2.4rem;

  ${({ theme }) => theme.media.laptop`
      padding: 0 0 2.4rem;
  `}
`;

export const IconListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const SelectedChartItemDetails = styled.div`
  margin-top: 1.6rem;
  padding: 0 1.2rem;
`;

export const PieChartContainer = styled.div``;

export const ChartChild = styled.div`
  width: 30%;

  margin-bottom: 1.2rem;
`;

export const Arrow = styled.div`
  bottom: 0.2rem;
`;

export const CustomDropDownIcon = styled(DropdownIcon)`
  transform: rotate(180deg);
  height: 2rem;
`;

export const BackButtonWrapper = styled(TransparentButton)`
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 0;
  left: 0;
  cursor: pointer;
  left: 1.6rem;

  ${({ theme }) => theme.media.laptop`
      left: 0;
      bottom: 1.6rem;
  `};
`;

export const PieChartWrapper = styled.div`
  padding: 0 6.5rem 3.2rem;
`;
